import { trackingAxios } from 'config/api/tracking'
import { IOrderRepository, OrderFilters } from 'orders/domain/repositories/IOrderRepository'
import { OrderListEntity, OrderSummaryEntity } from 'orders/domain/entities/order.entity'
import { OrderAdapter } from 'orders/infrastructure/adapters/OrderAdapter'

export class OrderHttpRepository implements IOrderRepository {
    async list(filters: OrderFilters): Promise<OrderListEntity> {
        try {
            const response = await trackingAxios.get('/orders', {
                params: filters,
            })
            return OrderAdapter.toDomainList(response.data)
        } catch (error) {
            console.error('[OrderHttpRepository] Error fetching orders list:', error)
            throw error
        }
    }

    async summary(): Promise<OrderSummaryEntity> {
        try {
            const response = await trackingAxios.get('/orders/summary')
            return OrderAdapter.toDomainSummary(response.data)
        } catch (error) {
            console.error('[OrderHttpRepository] Error fetching orders summary:', error)
            throw error
        }
    }
}
